"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopUp = function (_PureComponent) {
  _inherits(PopUp, _PureComponent);

  function PopUp() {
    _classCallCheck(this, PopUp);

    return _possibleConstructorReturn(this, (PopUp.__proto__ || Object.getPrototypeOf(PopUp)).apply(this, arguments));
  }

  _createClass(PopUp, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          display = _props.display,
          top = _props.top,
          left = _props.left,
          hideTooltip = _props.hideTooltip,
          breakpoint = _props.breakpoint,
          marginTop = _props.marginTop,
          childEl = _props.childEl;

      var tooltipStyling = {
        display: display,
        top: top,
        left: left,
        marginTop: (0, _ramda.isNil)(marginTop) ? 0 : marginTop,
        position: "absolute"
      };
      var mobileTooltipStyling = {};

      if (breakpoint < 3) {
        mobileTooltipStyling = (0, _ramda.omit)(["left", "top"], (0, _ramda.mergeRight)(tooltipStyling, { position: "fixed", bottom: "0%", backgroundColor: "#006496", width: "100%", textAlign: "center" }));
      }
      return _react2.default.createElement(
        "div",
        { "data-testid": "global-tooltip",
          className: "global-tooltip",
          style: tooltipStyling },
        breakpoint < 3 && _react2.default.createElement("div", { className: "modal-backdrop", style: { display: display }, onClick: hideTooltip }),
        _react2.default.createElement(
          "div",
          { id: "globalTooltip", style: mobileTooltipStyling, className: "headerTooltip popup-container" },
          _react2.default.createElement(
            "div",
            { className: "headerTipContent popup-content" },
            childEl
          )
        )
      );
    }
  }]);

  return PopUp;
}(_react.PureComponent);

exports.default = PopUp;